import { Button, Divider, Input, message, Select, Space } from "antd";
import { useEffect, useMemo, useState } from "react";

interface Props {
	disabled?: boolean;
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
	justInput?: boolean;
	readOnly?: boolean;
	allowClear?: boolean;
}
const InputPrivateEmail: React.FC<Props> = ({
	value,
	onChange,
	disabled,
	placeholder,
	justInput,
	readOnly,
	allowClear,
}) => {
	const [customDomain, setCustomDomain] = useState<string>("");
	const [domainList, setDomainList] = useState<string[]>([
		"@gmail.com",
		"@hotmail.com",
		"@remax.co.id",
		"@yahoo.co.id",
		"@yahoo.com",
	]);
	const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCustomDomain(event.target.value);
	};

	const useItem = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		if (customDomain.substring(0, 1) !== "@") {
			return message.error("Invalid email domain!");
		}
		setDomainList((prev) => [...prev, customDomain]);
		_handleDomainChange(customDomain);
		setCustomDomain("");
	};

	const splitted = useMemo(() => {
		let split = value?.split("@");
		let domain = split?.[1] ? "@" + split[1] : undefined;

		return [split?.[0], domain];
	}, [value]);

	useEffect(() => {
		if (splitted[1] && !domainList.includes(splitted[1])) {
			setDomainList((prev) => [...prev, splitted[1] as string]);
		}

		// eslint-disable-next-line
	}, [splitted]);

	const _handleAddressChange = (value: string) => {
		let split = value?.split("@");
		let customDomain = split[1];
		if (customDomain) {
			customDomain = "@" + customDomain;
			if (!domainList.includes(customDomain)) {
				setDomainList((prev) => [...prev, customDomain]);
			}
			_handleDomainChange(customDomain);
		}
		onChange?.(split[0] + (customDomain ?? splitted[1] ?? ""));
	};
	const _handleDomainChange = (value: string) => {
		if (value) {
			onChange?.((splitted[0] ?? "") + value);
		} else {
			onChange?.(splitted[0] ?? "");
		}
	};

	if (justInput) {
		return (
			<Input
				addonAfter={splitted?.[1]}
				value={splitted?.[0]}
				onChange={(e) => _handleAddressChange(e.target.value)}
				placeholder={placeholder}
				disabled={disabled}
				readOnly={readOnly}
			/>
		);
	}

	return (
		<Input.Group
			compact={true}
			style={{ display: "flex" }}
		>
			<Input
				value={splitted?.[0]}
				onChange={(e) => _handleAddressChange(e.target.value)}
				placeholder={placeholder}
				disabled={disabled}
				readOnly={readOnly}
			/>
			<Select
				style={{ width: 250 }}
				value={splitted?.[1]}
				options={domainList.map((v) => ({ label: v, value: v }))}
				onChange={_handleDomainChange}
				disabled={disabled}
				allowClear={allowClear}
				virtual={false}
				dropdownRender={(menu) => (
					<>
						{menu}
						<Divider style={{ margin: "8px 0" }} />
						<Space style={{ padding: "0 8px 4px" }}>
							<Input
								placeholder="@xxx.xx"
								value={customDomain}
								onChange={onNameChange}
							/>
							<Button
								size="small"
								type="text"
								onClick={useItem}
							>
								Use
							</Button>
						</Space>
					</>
				)}
			/>
		</Input.Group>
	);
};
export default InputPrivateEmail;
